<template>
  <div class="pageination">
    <nav aria-label="Page navigation example">
      <ul class="pagination mb-0 justify-content-center">
        <li class="page-item" v-if="pagingInfo.page > 1">
          <a
            class="page-link"
            href="javascript:"
            aria-label="Previous"
            @click="$emit('page', pagingInfo.page - 1)"
          >
            <i class="fas fa-angle-double-left"></i>
          </a>
        </li>
        <li
          v-for="(pageLink, i) in pageLinks"
          class="page-item"
          :key="`page-${i}`"
          :class="{
            active: !isNaN(pageLink) && parseInt(pageLink) == pagingInfo.page,
          }"
        >
          <a
            v-if="!isNaN(pageLink)"
            class="page-link"
            href="javascript:"
            @click="$emit('page', pageLink)"
          >
            {{ pageLink }}
          </a>
          <span style="line-height: 2rem" v-else> ... </span>
        </li>
        <li class="page-item" v-if="pages && pages.length > pagingInfo.page">
          <a
            class="page-link"
            href="javascript:"
            aria-label="Next"
            @click="$emit('page', pagingInfo.page + 1)"
          >
            <i class="fas fa-angle-double-right"></i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
  
  <script>
export default {
  props: ["pagingInfo"],
  computed: {
    pages() {
      let result = [];
      let pagingInfo = this.pagingInfo;
      if (pagingInfo) {
        let pageNum = Math.ceil(pagingInfo.total / pagingInfo.pageSize);
        for (let i = 0; i < pageNum; i++) {
          result.push(i + 1);
        }
      }
      return result;
    },

    pageLinks() {
      let result = [];
      let pages = this.pages;
      let currentPage = this.pagingInfo.page;
      pages.forEach((page) => {
        if (
          page == 1 ||
          page == 2 ||
          page == pages.length ||
          page == pages.length - 1 ||
          page == currentPage ||
          page == currentPage - 1 ||
          page == currentPage + 1
        ) {
          result.push(page);
        } else if (
          (page > 2 ||
            page < pages.length - 1 ||
            page == currentPage - 2 ||
            page == currentPage + 2) &&
          result.length &&
          result[result.length - 1] != "..."
        ) {
          result.push("...");
        }
      });
      return result;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.pageination {
  margin-bottom: 2rem;

  .page-item {
    span {
      line-height: 2.5rem;
      font-size: 1.5rem;
      color: #979797;
      padding: 10px 8px;
    }
  }
}
</style>